import Newsletter from "../../views/static/newsletter.vue"

document.addEventListener('DOMContentLoaded', () => {
    var element = document.getElementById('vue')
    if (element != null) {
        var app = new Vue({
            el: element,
            components: { Newsletter }
        })
        console.log(app)
    }
});